import dayjs from 'dayjs';

const isBefore = (date1: Date | string, date2: Date | string): boolean =>
  dayjs(date1).isBefore(date2);

export default isBefore;
